<template>
  <div class="page">
    <div id="__next">
      <div class="sc-jSMfEi dpRUBd">
        <div class="index_banner__s_mVD">
          <!-- ======= top1 ======= -->
          <div class="index_bannerWord__tQ_65">
            <div class="top1">
              <span
                style="box-sizing:border-box;display:block;overflow:hidden;width:initial;height:initial;background:none;opacity:1;border:0;margin:0;padding:0;position:absolute;top:0;left:0;bottom:0;right:0">
                <img alt="footer" src="@/images/banner.png"
                  style="position:absolute;top:0;left:0;bottom:0;right:0;box-sizing:border-box;padding:0;border:none;margin:auto;display:block;width:100%;height:0;min-width:100%;max-width:100%;min-height:100%;max-height:100%;object-fit:cover;object-position:center"
                  sizes="100vw">
              </span>
              <div class="row">
                <img src="@/images/logo.png" class="top_logo">
                <div class="login_info">
                  <div class="ppBtn" @click="$router.push('/PrivacyPolicy')">Privacy Policy</div>
                  <div id="username">das...54@gmail.com</div>
                  <div class="registerBtn" id="registerBtn" @click="openRegisterPage()">Register now for free</div>
                  <div class="registerBtn" id="registerBtn_out" @click="clickLoginOutBtn()">Log out</div>
                </div>
              </div>
              <div class="content1">Excellent Facebook AD agency the word of mouth choice for a large number of user
              </div>
              <div class="title">Game Wonder Limited</div>
              <div class="top_txt">
                <div class="col">
                  <div class="content2">
                    One-click self-service account opening
                  </div>
                  <div class="content2">
                    No fee for multi-currency recharge
                  </div>
                </div>
                <img src="@/images/line.png" class="top_line" />
                <div class="col">
                  <div class="content2">
                    Real-time conversion rate
                  </div>
                  <div class="content2">
                    Official agents are stable and secure
                  </div>
                </div>
                <img src="@/images/line.png" class="top_line" />
                <div class="col">
                  <div class="content2">
                    Intelligent advertising management system
                  </div>
                  <div class="content2">
                    Efficient delivery of orders
                  </div>
                </div>
              </div>
              <div class="registerBtn2" @click="openRegisterPage()">
                <div>Register now for free</div>
              </div>
            </div>
          </div>
        </div>
        <!-- ======= top2 ======= -->
        <div class="index_webStep1__S6aw7">
          <div class="occupied"></div>
          <div class="top_title">Game Wonder Limited expanding volume is a good helper</div>
          <div class="top_content">Manage Facebook ads efficiently, Making orders is easier</div>
          <div class="top2_box">
            <div class="top2_box_item">
              <img src="@/images/T1.png" alt="" class="top2_box_item_img" />
              <div class="top2_box_item_txt">No VPN, build <span class="txt_blue_color">a large</span> number of
                advertisements in seconds, <span class="txt_blue_color">quickly</span> test the effect, and quickly
                increase sales</div>
            </div>
            <div class="top2_box_item">
              <img src="@/images/T2.png" alt="" class="top2_box_item_img" />
              <div class="top2_box_item_txt">Custom rules automatically name ads, increasing productivity by <span
                  class="txt_blue_color">200%</span></div>
            </div>
            <div class="top2_box_item">
              <img src="@/images/T3.png" alt="" class="top2_box_item_img">
              <div class="top2_box_item_txt">You can copy ads within this account or across accounts, <span
                  class="txt_blue_color">without interruption</span></div>
            </div>
            <div class="top2_box_item">
              <img src="@/images/T4.png" alt="" class="top2_box_item_img">
              <div class="top2_box_item_txt"><span class="txt_blue_color">Lock</span> the target group, place the top
                delivery plan, optimize the budget allocation and advertising materials in a timely manner</div>
            </div>
            <div class="top2_box_item">
              <img src="@/images/T5.png" alt="" class="top2_box_item_img">
              <div class="top2_box_item_txt">Custom drop detection, <span class="txt_blue_color">real-time</span>
                reminder, automatic adjustment, edit at any time</div>
            </div>
            <div class="top2_box_item">
              <img src="@/images/T6.png" alt="" class="top2_box_item_img">
              <div class="top2_box_item_txt">Multi-dimensional advertising <span class="txt_blue_color">data
                  analysis</span>, regularly diagnose ads, check problems, and give suggestions for optimization</div>
            </div>
          </div>
          <div class="registerBtn2" @click="openRegisterPage()">
            <div>Register now for free</div>
          </div>
        </div>
        <!-- ======= top3 ======= -->
        <div class="index_webStep2__W_Z6X">
          <div class="occupied"></div>
          <div class="top_title">Game Wonder Limited Industry-wide marketing solutions</div>
          <div class="top3_box">
            <div class="top3_box_item">
              <div class="top3_box_item_left">
                <img src="@/images/icon-1.png" alt="" class="top3_box_item_img">
              </div>
              <div class="top3_box_item_right">
                <div>Delivery management</div>
                <div></div>
                <div class="top3_box_item_txt">No VPN, cross-platform cross-account one-stop advertising management,
                  fast and convenient</div>
              </div>
            </div>
            <div class="top3_box_item">
              <div class="top3_box_item_left">
                <img src="@/images/icon-2.png" alt="" class="top3_box_item_img">
              </div>
              <div class="top3_box_item_right">
                <div>Delivery management</div>
                <div></div>
                <div class="top3_box_item_txt">Independent station building, shop fine operation, full link service
                </div>
              </div>
            </div>
            <div class="top3_box_item">
              <div class="top3_box_item_left">
                <img src="@/images/icon-3.png" alt="" class="top3_box_item_img">
              </div>
              <div class="top3_box_item_right">
                <div>Delivery management</div>
                <div></div>
                <div class="top3_box_item_txt">Multi-dimensional advertising analysis, timely grasp the delivery effect
                  changes, at a glance</div>
              </div>
            </div>
            <div class="top3_box_item">
              <div class="top3_box_item_left">
                <img src="@/images/icon-4.png" alt="" class="top3_box_item_img">
              </div>
              <div class="top3_box_item_right">
                <div>Delivery management</div>
                <div></div>
                <div class="top3_box_item_txt">Massive boutique templates, suitable for a variety of marketing
                  scenarios, one click free use</div>
              </div>
            </div>
            <div class="top3_box_item">
              <div class="top3_box_item_left">
                <img src="@/images/icon-5.png" alt="" class="top3_box_item_img">
              </div>
              <div class="top3_box_item_right">
                <div>Delivery management</div>
                <div></div>
                <div class="top3_box_item_txt">200+ subdivided category data, hot product trend, marketing faster</div>
              </div>
            </div>
            <div class="top3_box_item">
              <div class="top3_box_item_left">
                <img src="@/images/icon-6.png" alt="" class="top3_box_item_img">
              </div>
              <div class="top3_box_item_right">
                <div>Delivery management</div>
                <div></div>
                <div class="top3_box_item_txt">7*24 hours, website compliance diagnosis, advertising automatic detection
                  optimization</div>
              </div>
            </div>
          </div>
          <div class="registerBtn2" @click="openRegisterPage()">
            <div>Register now for free</div>
          </div>
        </div>
        <!-- ======= top4 ======= -->
        <div class="index_webStep3__ZXbcq">
          <div class="top_title">Game Wonder Limited,Multi-industry success stories</div>
          <div class="top_content">Manage Facebook ads efficiently, Making orders is easier</div>
          <div class="top4_box">
            <div class="top4_box_item">
              <img src="@/images/TB-1.png" />
              <div class="top4_box_item_title">Create a traffic loop to increase sales</div>
              <div class="top4_box_item_content">Reasonable allocation of budget, through the advertising - website -
                business home page traffic connection, the number of Facebook page fans reached <span
                  class="top4_box_item_blue_txt">180,000+</span></div>
              <div class="top4_box_item_tags">
                <div class="top4_box_item_tags_txt">
                  <div>Number of Fans</div>
                </div>
                <div class="top4_box_item_tags_txt">
                  <div>CPA cost</div>
                </div>
                <div class="top4_box_item_tags_txt">
                  <div>Website purchase volume</div>
                </div>
              </div>
            </div>
            <div class="top4_box_item">
              <img src="@/images/TB-2.png" />
              <div class="top4_box_item_title">All-media reach increases brand rate</div>
              <div class="top4_box_item_content">In the early stage, Facebook media was the starting point, and in the
                middle stage, Google, Tiktok and other media cooperated with the promotion. In the later stage,
                multimedia integrated marketing made concerted efforts, and sales increased by <span
                  class="top4_box_item_blue_txt">28%</span></div>
              <div class="top4_box_item_tags">
                <div class="top4_box_item_tags_txt">
                  <div>Cost per purchase</div>
                </div>
                <div class="top4_box_item_tags_txt">
                  <div>Advertising ROI</div>
                </div>
                <div class="top4_box_item_tags_txt">
                  <div>Website purchase volume</div>
                </div>
              </div>
            </div>
            <div class="top4_box_item">
              <img src="@/images/TB-3.png" />
              <div class="top4_box_item_title">Conversion rate up to <span class="top4_box_item_blue_txt">32%</span>
              </div>
              <div class="top4_box_item_content">Use Facebook and Google search and shopping ads to promote brands and
                explosive products and increase conversion rates on the site</div>
              <div class="top4_box_item_tags">
                <div class="top4_box_item_tags_txt">
                  <div>Monthly AD views</div>
                </div>
                <div class="top4_box_item_tags_txt">
                  <div>Advertising ROI</div>
                </div>
                <div class="top4_box_item_tags_txt">
                  <div>In-station conversion rate</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- ======= top5 ======= -->
        <div class="index_webStep4__bHIhI">
          <span
            style="z-index: -1;box-sizing:border-box;display:block;overflow:hidden;width:initial;height:initial;background:none;opacity:1;border:0;margin:0;padding:0;position:absolute;top:0;left:0;bottom:0;right:0"><img
              alt="footer" src="@/images/BG-T.png"
              style="position:absolute;top:0;left:0;bottom:0;right:0;box-sizing:border-box;padding:0;border:none;margin:auto;display:block;width:0;height:0;min-width:100%;max-width:100%;min-height:100%;max-height:100%;object-fit:cover;object-position:center"
              sizes="100vw">
          </span>
          <div class="occupied"></div>
          <div class="top_title">Game Wonder Limited Industry-wide marketing solutions</div>
          <div class="top_content">From advertising account opening, marketing to effect analysis, everything is covered
          </div>
          <div class="top5_box">
            <div class="top5_box_item">
              <div class="top5_box_item_name">Email</div>
              <div class="top5_box_item_input">
                <div class="ant-form-item-control-input-content"><input placeholder="Please enter your email" id="11"
                    aria-required="true" class="ant-input ant-input-borderless phone-input" type="text" value="">
                </div>
              </div>
            </div>
            <div class="top5_box_item">
              <div class="top5_box_item_name">Password</div>
              <div class="top5_box_item_input">
                <div class="ant-form-item-control-input-content"><input placeholder="Please enter password" id="22"
                    aria-required="true" class="ant-input ant-input-borderless phone-input" type="text" value="">
                </div>
              </div>
            </div>
            <div class="registerBtn2" @click="openRegisterPage()">
              <div>Register now for free</div>
            </div>
          </div>
          <div class="top5_bottom_txt">Sign up now and have global traffic Blue Ocean</div>
        </div><!--$--><!--/$-->
        <!-- 底部1 -->
        <div class="bottom1">
          <div class="occupied"></div>
          <div class="bottom1_img">
            <img src="@/images/logo.png" alt="">
          </div>
          <div class="bottom1_box">
            <div class="bottom1_item">
              <div class="bottom1_item_content1">Sea-going plan</div>
              <div class="bottom1_item_line"></div>
              <div class="bottom1_item_content2">Overseas marketing</div>
              <div class="bottom1_item_content2">Affiliate Platforms</div>
              <div class="bottom1_item_content2">Native payment</div>
            </div>
            <div class="bottom1_item">
              <div class="bottom1_item_content1">Mainstream media</div>
              <div class="bottom1_item_line"></div>
              <div class="bottom1_item_content2">Google Marketing</div>
              <div class="bottom1_item_content2">Facebook Marketing</div>
              <div class="bottom1_item_content2">Other Traffic Channels</div>
            </div>
            <div class="bottom1_item">
              <div class="bottom1_item_content1">School of marketing</div>
              <div class="bottom1_item_line"></div>
              <div class="bottom1_item_content2">Google Optimization</div>
              <div class="bottom1_item_content2">Facebook Optimization</div>
              <div class="bottom1_item_content2">Gaming Industry</div>
              <div class="bottom1_item_content2">E-commerce Industry</div>
              <div class="bottom1_item_content2">Report Analysis</div>
              <div class="bottom1_item_content2">Latest Activities</div>
            </div>
            <div class="bottom1_item">
              <div class="bottom1_item_content1">About Game Wonder</div>
              <div class="bottom1_item_line"></div>
              <div class="bottom1_item_content2">Business introduction</div>
              <div class="bottom1_item_content2">Senior management team</div>
              <div class="bottom1_item_content2">Latest news</div>
              <div class="bottom1_item_content2">Global Presence</div>
            </div>
          </div>
        </div>
        <!-- 底部2 -->
        <div class="bottom2">
          <div>Copyright © 2024 Game Wonder Limited All Rights Reserved</div>
        </div>
      </div>
    </div>
    <div class="adm-px-tester" style="--size: 10;"></div>
    <div class="adm-px-tester"></div>
    <!-- <next-route-announcer>
      <p aria-live="assertive" id="__next-route-announcer__" role="alert"
        style="border: 0px; clip: rect(0px, 0px, 0px, 0px); height: 1px; margin: -1px; overflow: hidden; padding: 0px; position: absolute; width: 1px; white-space: nowrap; overflow-wrap: normal;">
      </p>
    </next-route-announcer> -->
    <iframe id="NECaptchaSafeWindow" style="display: none;"></iframe>
    <!-- 遮罩 -->
    <div id="mask">
      <div class="ant-modal-wrap">
        <div class="mask"></div>
      </div>
    </div>
    <!-- // 立即注册页面 -->
    <div>
      <div class="ant-modal-root">
        <div tabindex="-1" class="ant-modal-wrap" id="registerPage">
          <div role="dialog" aria-modal="true" class="ant-modal index_register-modal__U_s7z"
            style="width: 1028px; transform-origin: 990px -85px;">
            <div tabindex="0" style="width: 0px; height: 0px; overflow: hidden; outline: none;"></div>
            <div class="ant-modal-content">
              <button type="button" aria-label="Close" class="ant-modal-close" @click="closeRegisterPage()">
                <span class="ant-modal-close-x">
                  <span role="img" aria-label="close" class="anticon anticon-close ant-modal-close-icon"><svg
                      fill-rule="evenodd" viewBox="64 64 896 896" focusable="false" data-icon="close" width="1em"
                      height="1em" fill="currentColor" aria-hidden="true">
                      <path
                        d="M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z">
                      </path>
                    </svg>
                  </span>
                </span></button>
              <div class="ant-modal-body">
                <div class="index_register-modal-content__efImf">
                  <div class="index_register-modal-left__qrBpY"><img src="@/images/logo.png" alt="">
                    <div class="dialog_left_name">Game Wonder Limited</div>
                    <div class="dialog_left_txt">Growth-oriented cross-border advertising service platform</div>
                  </div>
                  <form class="ant-form ant-form-horizontal index_register-modal-form__XttgQ">
                    <h1 id="registerPageTitle">Register Now</h1>
                    <div class="index_phone-input-item__SBKFI">
                      <div class="ant-form-item">
                        <div class="ant-row ant-form-item-row">
                          <div class="ant-col ant-form-item-control">
                            <div class="register_txt">Email</div>
                            <div class="ant-form-item-control-input">
                              <div class="ant-form-item-control-input-content"><input
                                  placeholder="Please enter your email" id="email" aria-required="true"
                                  class="ant-input ant-input-lg" type="text" value=""></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="ant-form-item" id="verifyCodeItem">
                      <div class="ant-row ant-form-item-row">
                        <div class="ant-col ant-form-item-control">
                          <div class="register_txt">Verification Code</div>
                          <div class="ant-form-item-control-input">
                            <div class="ant-form-item-control-input-content">
                              <span class="ant-input-affix-wrapper ant-input-affix-wrapper-lg"><input
                                  placeholder="Enter the verification code" id="verifyCode" aria-required="true"
                                  class="ant-input ant-input-lg" type="text" value=""><span class="ant-input-suffix">
                                  <div class="index_fetch-msg-code__v2WQ9" @click="clickSendVerifiyCode()"><span
                                      class="registerPage_color">Get verification code</span></div>
                                </span>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="index_captcha_wrap__c6Gzh" id="sino-marketing-modal-captcha"
                      style="position: relative;">
                      <input type="hidden" name="NECaptchaValidate" value="" class="yidun_input">
                    </div>
                    <div class="ant-form-item">
                      <div class="ant-row ant-form-item-row">
                        <div class="ant-col ant-form-item-control">
                          <div class="register_txt">Password</div>
                          <div class="ant-form-item-control-input">
                            <div class="ant-form-item-control-input-content">
                              <span
                                class="ant-input-affix-wrapper ant-input-password ant-input-password-large ant-input-affix-wrapper-lg"><input
                                  placeholder="Please enter password" id="password" aria-required="true" type="password"
                                  class="ant-input ant-input-lg">
                                <span class="ant-input-suffix">
                                </span></span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div id="login_fail_message">Something wrong, please check your email and password and try again.
                      </div>
                    </div>
                    <button type="button" class="ant-btn ant-btn-primary index_register-btn__VnUhW"
                      id="registerPageBtnTxt" @click="clickRegisterBtn()"><span>Register now</span></button>
                    <div class="index_type-change___Bu8o"><span id="accountTipsTxt">Existing account?</span><span
                        class="registerPage_color" id="changeTxt" @click="changeLoginPage()">Go and login</span></div>
                  </form>
                </div>
              </div>
            </div>
            <div tabindex="0" style="width: 0px; height: 0px; overflow: hidden; outline: none;"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 注册成功页面 -->
    <div id="registerSuccessPage">
      <div class="ant-modal-wrap">
        <div class="register_success_page">
          <div id="registerSuccessPageTitle">Register Successful</div>
          <div>We'll contact you immediately!</div>
          <div @click="closeRegisterSuccessPage()">Confirm</div>
        </div>
      </div>
    </div>
    <!-- 消息提示框 -->
    <div id="messageTips">
      <div class="ant-modal-wrap">
        <div id="message">
          The verification code is sent successfully.
        </div>
      </div>
    </div>
  </div>
</template>


<script>

import '@/css/style2.css'
import '@/css/style4.css'
export default {
  title: "Game Wonder Limited",
  name: 'LimitedComponentView',
  data: function () {
    return {

    }
  },
  props: {

  },
  mounted: function () {

    this.url = "https://api.gamewonderads.com"

    this.registerPageChangeStatus = 0; // 0: 注册页面，1：登录页面
    this.loginStatus = false; // 登录状态

    this.mask = document.getElementById("mask");
    this.registerPage = document.getElementById("registerPage");
    this.registerSuccessPage = document.getElementById("registerSuccessPage");
    this.logoutBtn = document.getElementById("registerBtn_out");
    this.registerBtn = document.getElementById("registerBtn");
    this.username = document.getElementById("username");
    this.registerSuccessPageTitle = document.getElementById("registerSuccessPageTitle");
    this.verifyCodeItem = document.getElementById("verifyCodeItem");
    this.registerPageTitle = document.getElementById("registerPageTitle");
    this.registerPageBtnTxt = document.getElementById("registerPageBtnTxt");
    this.accountTipsTxt = document.getElementById("accountTipsTxt");
    this.changeTxt = document.getElementById("changeTxt");

    this.email = document.getElementById("email");
    this.verifyCode = document.getElementById("verifyCode");
    this.password = document.getElementById("password");

    this.messageBox = document.getElementById('messageTips');
    this.messageTxt = document.getElementById('message');
    this.loginFailMessage = document.getElementById("login_fail_message");
    this.init();

    // this.openRegisterPage();
  },
  beforeDestroy: function () {

  },
  methods: {
    // 初始化
    init: function () {
      this.mask.style.display = "none"; // 隐藏遮罩
      this.registerSuccessPage.style.display = "none";  // 隐藏注册成功页面
      this.registerPage.style.display = "none"; // 隐藏注册页面
      this.logoutBtn.style.display = "none"; // 隐藏logout按钮
      this.username.style.display = "none"; // 隐藏用户名
      this.checkIsToken();
    },
    // 打开注册页面
    openRegisterPage: function () {
      this.loginFailMessage.style.display = 'none'
      this.registerPage.style.display = "block";
      this.mask.style.display = "block";
    },
    // 关闭注册成功页面
    openRegisterSuccessPage: function (type) {
      if (type == 0) {
        this.registerSuccessPageTitle.textContent = "Register Successful";
      } else if (type == 1) {
        this.registerSuccessPageTitle.textContent = "Login Successful";
      }
      this.registerSuccessPage.style.display = "block";
      this.mask.style.display = "block";
    },
    // 切换注册/登录页面
    changeLoginPage: function () {
      if (this.registerPageChangeStatus == 0) {
        this.verifyCodeItem.style.display = "none";
        this.registerPageTitle.textContent = "Login";
        this.registerPageBtnTxt.textContent = "Sign in Now";
        this.accountTipsTxt.textContent = "No account?";
        this.changeTxt.textContent = "Go to register";
      } else {
        this.verifyCodeItem.style.display = "block";
        this.registerPageTitle.textContent = "Register Now";
        this.registerPageBtnTxt.textContent = "Register Now";
        this.accountTipsTxt.textContent = "Existing account?";
        this.changeTxt.textContent = "Go and login";
      }
      this.registerPageChangeStatus = this.registerPageChangeStatus == 0 ? 1 : 0
    },
    // 点击注册按钮
    clickRegisterBtn: function () {
      let emailTxt = this.email.value;
      let passwordTxt = this.password.value;
      let verifyCodeTxt = this.verifyCode.value;

      if (this.registerPageChangeStatus == 0) {
        if (emailTxt == "" || passwordTxt == "" || verifyCodeTxt == "") {
          this.loginFailMessage.textContent = "Please enter email, password and verify code!"
          this.loginFailMessage.style.display = 'block'
          return;
        }
        // 注册
        fetch(this.url + '/v1/user/register', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json' // 设置请求头为JSON
          },
          body: JSON.stringify({
            "oaid": Math.random().toString(36).substr(2),
            "email": emailTxt,
            "password": window.CryptoJS.MD5(passwordTxt).toString(),
            "confirm_password": window.CryptoJS.MD5(passwordTxt).toString(),
            "verify_code": verifyCodeTxt
          })
        })
          .then(response => response.json())
          .then(data => {
            if (data.code == 1) {
              var res = JSON.parse(atob(data.data))

              console.error("注册成功", res)

              // var username = document.getElementById("username")
              this.username.textContent = this.usernameChange(res.user.username)
              this.loginStatus = true;

              localStorage.setItem("token", res.token)
              localStorage.setItem("time", new Date().getTime())
              localStorage.setItem("username", this.usernameChange(res.user.username))

              // this.showMessageByType(1, "login success!")
              this.openRegisterSuccessPage(0);
              this.closeRegisterPage();
              this.openRegisterSuccessPage(0);
              this.checkIsToken();
            } else {
              this.loginFailMessage.textContent = "Something wrong, please check your verify code and try again."
              this.loginFailMessage.style.display = 'block'
            }
          })
          .catch(error => {
            console.error('Error:', error);
          })
      } else {
        if (emailTxt == "" || passwordTxt == "") {
          this.loginFailMessage.textContent = "Please enter email, password!"
          this.loginFailMessage.style.display = 'block'
          return;
        }
        // 登录
        fetch(this.url + '/v1/user/login', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json' // 设置请求头为JSON
          },
          body: JSON.stringify({
            "email": emailTxt,
            "password": window.CryptoJS.MD5(passwordTxt).toString(),
            "platform": 0,
            // "pkg_name": "web",
            "country": "HK",
            "province": "Hong Kong",
            "phone_model": "小米10",
            "phone_os_version": "安卓11",
            "app_version": "1.0.0"
          })
        })
          .then(response => response.json())
          .then(data => {
            if (data.code == 1) {
              var res = JSON.parse(atob(data.data))

              console.error("登录成功", res)

              // var username = document.getElementById("username")
              this.username.textContent = this.usernameChange(res.user.username)
              this.loginStatus = true;

              localStorage.setItem("token", res.token)
              localStorage.setItem("time", new Date().getTime())
              localStorage.setItem("username", this.usernameChange(res.user.username))

              // this.showMessageByType(1, "login success!")
              this.openRegisterSuccessPage(1);
              this.closeRegisterPage();
              this.openRegisterSuccessPage(1);
              this.checkIsToken();
            } else {
              this.loginFailMessage.textContent = "Something wrong, please check your email and password and try again."
              this.loginFailMessage.style.display = 'block'
            }
          })
          .catch(error => {
            console.error('Error:', error);
          })
      }
    },
    usernameChange: function (s) {
      // 找到@的位置
      const atIndex = s.indexOf('@');

      // 如果没有@或者@在字符串前三个字符之前，不进行替换
      if (atIndex === -1 || atIndex < 3) {
        return s;
      }

      // 替换从第四个字符到@前两个字符之间的部分
      return s.substring(0, 3) + '*'.repeat(atIndex - 5) + s.substring(atIndex - 2);
    },
    // 检查登录
    checkIsToken: function () {
      if (localStorage.getItem("time") == null) return false
      let curTime = new Date().getTime()
      let sevenTime = 7 * 24 * 60 * 60 * 1000
      if (curTime - localStorage.getItem("time") > sevenTime) {
        localStorage.removeItem("token")
        localStorage.removeItem("time")
        localStorage.removeItem("username")
        return false
      }
      this.username.textContent = localStorage.getItem("username")
      this.registerBtn.style.display = "none";
      this.logoutBtn.style.display = "block";
      this.username.style.display = "block";
      return true
    },
    // 关闭注册页面
    closeRegisterPage: function () {
      this.registerPage.style.display = "none";
      this.mask.style.display = "none";
    },
    // 关闭注册成功页面
    closeRegisterSuccessPage: function () {
      this.registerSuccessPage.style.display = "none";
      this.mask.style.display = "none";
    },
    // 退出登录
    clickLoginOutBtn: function () {
      localStorage.removeItem("token")
      localStorage.removeItem("time")
      localStorage.removeItem("username")

      this.showMessageByType(1, "Logout successfully!")

      this.registerBtn.style.display = "block";
      this.logoutBtn.style.display = "none";
      this.username.style.display = "none";
    },
    // 发送验证码
    clickSendVerifiyCode: function () {
      let emailTxt = this.email.value;
      if (emailTxt == "") {
        this.showMessageByType(0, "Please fill in the correct email address!")
        return
      }
      fetch(this.url + '/v1/user/verify_email', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json' // 设置请求头为JSON
        },
        body: JSON.stringify({
          "email": emailTxt,
        })
      })
        .then(response => response.json())
        .then(data => {
          if (data.code == 1) {
            // var res = JSON.parse(atob(data.data))
            this.showMessageByType(1, "The verification code is sent successfully.")
          } else {
            this.showMessageByType(0, "Failed to send the verification code.")
          }
        })
        .catch(error => {
          console.error('Error:', error);
        })
    },
    showMessage: function () {
      this.messageBox.style.top = '40px'; // 滑动到顶部位置
    },

    hideMessage: function () {
      this.messageBox.style.top = '-100px'; // 滑动到屏幕外
    },

    showMessageByType: function (type, msg) {
      this.messageTxt.textContent = msg
      if (type == 1) {
        this.messageBox.style.width = "350px"
        this.messageBox.style.backgroundColor = "#67C23A"
      } else {
        this.messageBox.style.width = "350px"
        this.messageBox.style.backgroundColor = "#F56C6C"
      }
      setTimeout(this.showMessage, 50);
      setTimeout(this.hideMessage, 3000);
    }

  }

}
// this.init()

</script>
<style scoped>
.page {
  width: 100vw;
}

.row {
  display: flex;
  width: 100%;
  justify-content: space-between;
}

.col {
  flex-direction: column;
}

.col :last-child {
  margin-top: 15px;
}

.index_bannerWord__tQ_65 {
  width: 100%;
  height: 692px;
  top: 0;
}

.top1 {
  margin: auto;
  width: 1100px;
  height: 692px;
}

.top1 span {
  z-index: -1;
}

.top_logo {
  margin-top: 15px;
  width: 350px;
  height: 64px;
}

.login_info {
  display: flex;
  height: 79px;
}

#username {
  margin-top: 22px;
  margin-right: 22px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 18px;
  color: #FFFFFF;
}

.registerBtn {
  margin-top: 12.5px;
  height: 45px;
  padding: 8px 17px 8px 17px;
  border-radius: 3px;
  border: 1px solid #FFFFFF;
  cursor: pointer;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 18px;
  color: #FFFFFF;
}

.ppBtn {
  margin-top: 12.5px;
  height: 45px;
  padding: 8px 17px 8px 17px;
  cursor: pointer;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 18px;
  color: #FFFFFF;
}

.content1 {
  margin-top: 125px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: 26px;
  color: #FFFEFE;
  opacity: 0.8;
}

.title {
  margin-top: 51px;
  height: 49px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: 60px;
  color: #FFFFFF;
}

.content2 {
  width: 299px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: 20px;
  color: #FFFEFE;
  line-height: 24px;
  opacity: 0.8;
  text-align: center;
}

.top_line {
  margin: 0 48px;
  margin-top: 2px;
  width: 2px;
  height: 61px;
}

.top_txt {
  display: flex;
  margin-top: 124px;
}

.registerBtn2 {
  width: 340px;
  height: 54px;
  margin: 0 auto;
  background: #FF319C;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.registerBtn2 div {
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: 26px;
  color: #FFFEFE;
  line-height: 24px;
}

/* 第二层 */
.index_webStep1__S6aw7 {
  margin-top: 21px;
  width: 100%;
  height: 1306px;
}

.top_title {
  margin: auto;
  margin-top: 100px;
  width: 1050px;
  height: 124px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: 60px;
  color: #3E4045;
  line-height: 60px;
  text-align: center;
}

.top_content {
  margin: auto;
  margin-top: 8px;
  width: 1061px;
  height: 39px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: 36px;
  color: #00A7F5;
  line-height: 60px;
  text-align: center;
}

.top2_box {
  margin: auto;
  margin-top: 49px;
  width: 1084px;
  height: 783px;
  /* background-color: #d2f4ef; */
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

.top2_box :nth-child(3n) {
  margin-right: 0px;
}

.top2_box :nth-child(n+4) {
  margin-bottom: 0px;
}

.top2_box_item {
  margin-right: 29px;
  margin-bottom: 31px;
  width: 342px;
  height: 376px;
  background: #FFFFFF;
  border: 1px solid #E6E6E6;
  /* background-color: #9ba7b8; */
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.top2_box_item_img {
  width: 340px;
  height: 250px;
}

.top2_box_item_txt {
  margin-top: 18px;
  width: 298px;
  height: 82px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 18px;
  color: #818181;
  line-height: 22px;
}

.txt_blue_color {
  color: #00A7F5;
}

.index_webStep1__S6aw7 .registerBtn2 {
  margin-top: 50px;
  background-color: #00A7F5;
}

/* 第三层 */
.index_webStep2__W_Z6X {
  height: 1008px;
}

.occupied {
  height: 1px;
  width: 100%;
}

.top3_box {
  margin: auto;
  margin-top: 49px;
  width: 1100px;
  height: 532px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

.top3_box :nth-child(2n) {
  margin-right: 0px;
}

.top3_box :nth-child(n+5) {
  margin-bottom: 0px;
}

.top3_box_item {
  margin-right: 28px;
  margin-bottom: 20px;
  width: 536px;
  height: 164px;
  background: #FFFFFF;
  border: 1px solid #E6E6E6;
  display: flex;
}

.top3_box_item_img {
  position: relative;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}

.top3_box_item_txt {
  margin-top: 18px;
  width: 298px;
  height: 82px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 18px;
  color: #818181;
  line-height: 22px;
}

.top3_box_item_left {
  margin: 27px 26px 27px 21px;
  width: 110px;
  height: 110px;
  background: #FFFFFF;
  border-radius: 50%;
  border: 3px solid #F4F5FB;
  display: flex;
}

.top3_box_item_right {
  display: flex;
  flex-direction: column;
}

.top3_box_item_right :first-child {
  margin-top: 27px;
  width: 231px;
  height: 22px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: 20px;
  color: #3E4045;
  line-height: 20px;
}

.top3_box_item_right :nth-child(2) {
  margin-top: 15px;
  width: 343px;
  height: 2px;
  border: 1px solid #E6E6E6;
}

.top3_box_item_right :nth-child(3) {
  margin-top: 15px;
  width: 339px;
  height: 56px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 18px;
  color: #818181;
  line-height: 20px;
}

.index_webStep2__W_Z6X .registerBtn2 {
  margin-top: 50px;
  background-color: #00A7F5;
}

/* 第四层 */
.index_webStep3__ZXbcq {
  height: 993px;
}

.top4_box {
  margin: auto;
  margin-top: 49px;
  width: 1100px;
  height: 670px;
  display: flex;
  flex-wrap: wrap;
}

.top4_box_item {
  margin-right: 28px;
  width: 348px;
  height: 670px;
  background: #FFFFFF;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.2);
  border-radius: 20px;
}

.top4_box :last-child {
  margin-right: 0px;
}

.top4_box_item_title {
  margin: 30px 0px 35px 21px;
  width: 305px;
  height: 43px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: 22px;
  color: #3E4045;
  line-height: 24px;
}

.top4_box_item_content {
  margin-left: 20px;
  width: 305px;
  height: 152px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 18px;
  color: #818181;
  line-height: 24px;
}

.top4_box_item_blue_txt {
  font-size: 32px;
  color: #00A7F5;
  font-weight: bold;
}

.top4_box_item_tags {
  display: flex;
  flex-wrap: wrap;
  margin-top: 78px;
  margin-left: 21px;
}

.top4_box_item_tags_txt {
  margin-right: 10px;
  margin-bottom: 10px;
  padding: 0px 10px;
  height: 28px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 14px;
  color: #3E4045;
  line-height: 28px;
  display: flex;
  background: #DAE8FF;
  border-radius: 14px;
  justify-content: center;
  align-items: center;
  text-align: center;
}

/* 第五层 */
.index_webStep4__bHIhI {
  width: 100%;
  height: 876px;
  /* background-image: url(../images/BG-T.png); */
  background-repeat: no-repeat;
  margin: auto;
}

.index_webStep4__bHIhI .top_content {
  height: 79px;
  line-height: 40px;
}

.top5_box {
  margin: auto;
  margin-top: 50px;
  width: 670px;
  height: 330px;
  background: #FFFFFF;
  border-radius: 8px;
  opacity: 0.8;
}

.top5_box_item {
  padding-top: 61px;
  width: 100%;
  height: 42px;
  display: flex;
  justify-content: center;
}

.top5_box_item_name {
  width: 78px;
  height: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 18px;
  color: #3E4045;
  line-height: 40px;
  text-align: right;
}

.top5_box_item_input {
  margin-left: 13px;
  width: 312px;
  height: 42px;
  background: #FFFFFF;
  border-radius: 4px;
  border: 2px solid #E6E6E6;
  display: flex;
  align-items: center;
  justify-content: center;
}

.top5_box_item_input input {
  width: 300px;
  height: 40px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 16px;
  color: rgb(0 0 0 / 85%);
  line-height: 40px;
}

.index_webStep4__bHIhI .registerBtn2 {
  margin-top: 80px;
}

.top5_bottom_txt {
  margin: auto;
  margin-top: 50px;
  width: 781px;
  height: 34px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: 32px;
  color: #3E4045;
  line-height: 40px;
  text-align: center;
}

/* 底部 */
.bottom1 {
  width: 100%;
  height: 648px;
  background-color: #043DA6;
}

.bottom1_img {
  margin: auto;
  width: 1082px;
  margin-top: 100px;
}

.bottom1_box {
  display: flex;
  margin: auto;
  margin-top: 54px;
  width: 1082px;
  height: 331px;
}

.bottom1_item {
  margin-right: 47px;
  width: 235px;
}

.bottom1_box :last-child {
  margin-right: 0;
}

.bottom1_item div {
  margin-bottom: 22px;
}

.bottom1_item_content1 {
  height: 24px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: 22px;
  color: #FFFFFF;
  line-height: 24px;
}

.bottom1_item_content2 {
  font-weight: 400;
  font-size: 18px;
  color: #FFFFFF;
  line-height: 24px;
}

.bottom1_item_line {
  width: 80px;
  height: 6px;
  background: #00A7F5;
}

.bottom2 {
  width: 100%;
  height: 128px;
  background-color: #00A7F5;
}

.bottom2 div {
  margin: auto;
  width: 544px;
  height: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 18px;
  color: #FFFFFF;
  line-height: 128px;
  text-align: center;
}

/* .index_register-modal-left__qrBpY {
  background-image: url("../images/register-bg.png") no-repeat;
} */
/* 弹框 */
.dialog_left_name {
  margin: auto;
  margin-top: 180px;
  width: 359px;
  height: 27px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: 32px;
  color: #FFFFFF;
  line-height: 36px;
  opacity: 1;
}

.dialog_left_txt {
  margin: auto;
  margin-top: 19px;
  width: 398px;
  height: 45px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 20px;
  color: #FFFFFF;
  line-height: 24px;
}

.register_txt {
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 18px;
  color: #3E4045;
}

.index_fetch-msg-code__v2WQ9 {
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 14px;
  color: #00A7F5;
  text-decoration-line: underline;
}

#registerPageBtnTxt {
  background: #00A7F5;
  border-radius: 4px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: 24px;
  color: #FFFEFE;
  line-height: 24px;
}

.registerPage_color {
  color: #00A7F5;
  text-decoration-line: underline;
}

.ant-modal-close-x {
  /* background-color: #0776f8; */
  display: flex;
  justify-content: center;
  align-items: center;
}

#accountTipsTxt {
  color: #3E4045;
}

/* 注册成功页面 */
#registerSuccessPage .ant-modal-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
}

.register_success_page {
  position: fixed;
  /* left: 50%;
  top: 50%; */
  margin: auto;
  width: 500px;
  height: 287px;
  background: #FFFFFF;
  border-radius: 10px;
  opacity: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.register_success_page :first-child {
  height: 31px;
  margin-top: 60px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: 28px;
  color: #3E4045;
  line-height: 36px;
}

.register_success_page :nth-child(2) {
  margin-top: 26px;
  height: 22px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 20px;
  color: #3E4045;
  line-height: 40px;
}

.register_success_page :last-child {
  margin-top: 40px;
  width: 378px;
  height: 48px;
  background: #00A7F5;
  border-radius: 4px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: 24px;
  color: #FFFEFE;
  line-height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

/* mask */
.mask {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: #000;
  opacity: 0.5;
  z-index: 1;
}

/* 提示框 */
#messageTips {
  position: fixed;
  top: -100px;
  /* 初始位置在屏幕外 */
  left: 50%;
  width: 350px;
  height: 50px;
  line-height: 50px;
  font-size: 16px;
  transform: translateX(-50%);
  background-color: #67C23A;
  color: #fff;
  padding: 10px;
  border-radius: 5px;
  /* box-shadow: 0 2px 5px #67C23A; */
  z-index: 1000;
  transition: top 0.5s;
  /* 动画效果 */
  text-align: center;
}

#login_fail_message {
  color: red;
}
</style>